/* eslint-disable */
export enum Breakpoints {
    xs = 0,
    sm = 414,
    md = 768,
    lg = 1024,
    xl = 1440,
    xxl = 1984,
}
